import { PayloadAction } from '../../../../../store.model';
import { ActionType } from '../commitment-narrative.action';
import { State } from '../commitment-narrative.state';
import { filterRowsByCreator } from '../functions/filter-rows-by-creator.function';
import { filterRowsByDateRange } from '../functions/filter-rows-by-date-range.function';
import { filterRowsByLastUpdatedBy } from '../functions/filter-rows-by-update-by.function';
import { DateFilterType } from '../models/data-filter-type.enum';

import { ApplyFilters } from './filter.action';

export function applyFiltersReducer(
    state: State,
    action: PayloadAction<ActionType, ApplyFilters>,
): State {
    try {
        let nextFiltered = [...state.rows];

        const isCreatedEnabled =
            action.payload.opts.enabledFilters[DateFilterType.Created] === true;
        if (isCreatedEnabled) {
            nextFiltered = filterRowsByDateRange(
                action.payload.opts.createdRange,
                nextFiltered,
            );
        }

        const isLastUpdatedEnabled =
            action.payload.opts.enabledFilters[DateFilterType.LastUpdated] ===
            true;
        if (isLastUpdatedEnabled) {
            nextFiltered = filterRowsByDateRange(
                action.payload.opts.lastUpdatedOnRange,
                nextFiltered,
            );
        }
        nextFiltered = filterRowsByCreator(
            action.payload.opts.createdBy,
            nextFiltered,
        );
        nextFiltered = filterRowsByLastUpdatedBy(
            action.payload.opts.lastUpdatedBy,
            nextFiltered,
        );

        return {
            ...state,
            filteredRow: nextFiltered,
            filterOpts: action.payload.opts,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
